module.exports = __webpack_public_path__ + "static/media/savvy-js-ipfs-io.cf8f208f.svg";